import API from "@/api/lib/api";

export const getAllKebabs = async (restaurant_id) => {
  try {
    const response = await API.get(`restaurant/${restaurant_id}/kebabs`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleKebab = async (item_id) => {
  try {
    const response = await API.get(`restaurant/kebabs/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};


export const createKebab = async (data) => {
  try {
    const response = await API.post(`restaurant/kebabs`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};



export const updateKebab = async (item_id, data) => {
  try {
    const response = await API.put(`restaurant/kebabs/${item_id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};


export const deleteKebab = async (item_id) => {
  try {
    const response = await API.delete(`restaurant/kebabs/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};